/**
 * Single definition of "drop the act-as / impersonation context" (S-1.3).
 *
 * Both tokens are sessionStorage-backed and make api() travel as the administered
 * client / impersonated user. They must be cleared at well-defined lifecycle
 * points — sign-out, a different user signing in (see onboarding-reset.ts), and
 * entering the firm/platform console (you cannot be "administering a client"
 * while standing in the firm console). Keeping ONE definition here means that
 * security-critical clear can never drift between call sites.
 */

import { useFirmActStore } from './firm-act-store';
import { useImpersonationStore } from './impersonation-store';

export function clearActAsContext(): void {
  useFirmActStore.getState().clear();
  useImpersonationStore.getState().clear();
}
